import _ from 'lodash'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'
import testScorecardItemSerie from './test-scorecard-item-serie'

/**
 * A bootslide endpoint for select scorecard items that are valid for charts
 */
const ChartScorecardItemEndpoint = AddDomainObjectEndpoint.extend({
	selectorOptions: function(opt) {
		var selectorOpts = AddDomainObjectEndpoint.prototype.selectorOptions.apply(this, arguments)

		return _.extend(selectorOpts, {
			params: {
				// need the scoring type so I can prevent unscored text metrics
				scoringType: true
			}
		})
	},

	allowSelect: function (node) {
		return !testScorecardItemSerie(node)
	}
})

export default ChartScorecardItemEndpoint

ChartScorecardItemEndpoint.__filename__ = 'charts/edit/serie/chart-scorecard-item-endpoint.js'
